<template>
  <div v-if="mytype == 'WINE'">
    <!--<div v-if="attr?.v">
      <img src="@/assets/vintage.svg" />&nbsp;{{ attr?.v }}
    </div>-->
    <div v-if="attr?.co"><img src="@/assets/country.svg" />&nbsp;{{ attr?.co }}</div>
    <div v-if="attr?.r"><img src="@/assets/region.svg" />&nbsp;{{ attr?.r }}</div>

    <div v-if="attr?.c">
      <img src="@/assets/wine-white.svg" v-if="attr?.c == 'White'" />
      <img src="@/assets/wine-red.svg" v-else-if="attr?.c == 'Red'" />
      <img src="@/assets/wine-rose.svg" v-else-if="attr?.c == 'Rose'" />
      <img src="@/assets/wine-orange.svg" v-else-if="attr?.c == 'Orange'" />
      <img src="@/assets/wine-white.svg" v-else />
      {{ attr?.c }} <span v-if="attr?.wt">&nbsp;&mdash;&nbsp;{{ removeNumbersDash() }}</span>
    </div>

    <div v-if="attr?.va"><img src="@/assets/wine-varietal.svg" />&nbsp;{{ attr?.va }}</div>
    <div v-if="attr?.rs"><img src="@/assets/rs-levels.svg" />&nbsp;{{ attr?.rs }}</div>
    <div v-if="attr?.fp"><img src="@/assets/farming.svg" />&nbsp;{{ attr?.fp }}</div>
    <div v-if="attr?.st"><img src="@/assets/spirit-type.svg" />&nbsp;{{ attr?.st }}</div>
    <div v-if="attr?.sst"><img src="@/assets/spirit-sub.svg" />&nbsp;{{ attr?.sst }}</div>
    <div v-if="attr?.ap"><img src="@/assets/appellation.svg" />&nbsp;{{ attr?.ap }}</div>
    <div v-if="attr?.k"><img src="@/assets/kosher.svg" />&nbsp;{{ attr?.k }}</div>
  </div>
  <!-- NEW TYPE -->
  <div v-else-if="mytype == 'SAKE'">
    <div v-if="attr?.r"><img src="@/assets/region.svg" />&nbsp;{{ attr?.r }}</div>
    <div v-if="attr?.st"><img src="@/assets/sake-type.svg" />&nbsp;{{ attr?.st }}</div>
    <div v-if="attr?.va"><img src="@/assets/sake-varietal.svg" />&nbsp;{{ attr?.va }}</div>
    <div v-if="attr?.rs"><img src="@/assets/rs-levels.svg" />&nbsp;{{ attr?.rs }}</div>
    <div v-if="attr?.sk"><img src="@/assets/sake-varietal.svg" />&nbsp;{{ attr?.sk }}</div>
    <!--<div v-if="attr?.rs"><img src="@/assets/rs-levels.svg" />&nbsp;{{ attr?.rc }}</div>-->
    <div v-if="attr?.k"><img src="@/assets/kosher.svg" />&nbsp;{{ attr?.k }}</div>
  </div>
  <!-- NEW TYPE -->
  <div v-else-if="mytype == 'SPIRITS'">
    <div v-if="attr?.v"><img src="@/assets/vintage.svg" />&nbsp;{{ attr?.v }}</div>
    <div v-if="attr?.co"><img src="@/assets/country.svg" />&nbsp;{{ attr?.co }}</div>
    <div v-if="attr?.r"><img src="@/assets/region.svg" />&nbsp;{{ attr?.r }}</div>
    <div v-if="attr?.st"><img src="@/assets/spirit-type.svg" />&nbsp;{{ attr?.st }}</div>
    <div v-if="attr?.sst"><img src="@/assets/spirit-sub.svg" />&nbsp;{{ attr?.sst }}</div>
    <div v-if="attr?.k"><img src="@/assets/kosher.svg" />&nbsp;{{ attr?.k }}</div>
  </div>
  <!-- NEW TYPE -->
  <div v-else-if="mytype == 'CIDER'">
    <div v-if="attr?.co"><img src="@/assets/country.svg" />&nbsp;{{ attr?.co }}</div>
    <div v-if="attr?.r"><img src="@/assets/region.svg" />&nbsp;{{ attr?.r }}</div>
    <div v-if="attr?.ap"><img src="@/assets/appellation.svg" />&nbsp;{{ attr?.ap }}</div>
    <div v-if="attr?.c"><img src="@/assets/cider-color.svg" />&nbsp;{{ attr?.c }}</div>
    <div v-if="attr?.rs"><img src="@/assets/rs-levels.svg" />&nbsp;{{ attr?.rs }}</div>

    <div v-if="attr?.fp"><img src="@/assets/farming.svg" />&nbsp;{{ attr?.fp }}</div>
    <div v-if="attr?.k"><img src="@/assets/kosher.svg" />&nbsp;{{ attr?.k }}</div>
  </div>
  <div v-else-if="mytype == 'HOSPITALITY SPIRITS'">
    <div v-if="attr?.co"><img src="@/assets/country.svg" />&nbsp;{{ attr?.co }}</div>
    <div v-if="attr?.r"><img src="@/assets/region.svg" />&nbsp;{{ attr?.r }}</div>
    <div v-if="attr?.st"><img src="@/assets/spirit-type.svg" />&nbsp;{{ attr?.st }}</div>

    <div v-if="attr?.fp"><img src="@/assets/farming.svg" />&nbsp;{{ attr?.fp }}</div>
    <div v-if="attr?.k"><img src="@/assets/kosher.svg" />&nbsp;{{ attr?.k }}</div>
  </div>
  <div v-else>
    <!--<div v-if="attr?.v">
      <img src="@/assets/vintage.svg" />&nbsp;{{ attr?.v }}
    </div>-->
    <div v-if="attr?.co"><img src="@/assets/country.svg" />&nbsp;{{ attr?.co }}</div>
    <div v-if="attr?.r"><img src="@/assets/region.svg" />&nbsp;{{ attr?.r }}</div>

    <div v-if="attr?.c">
      <img src="@/assets/wine-white.svg" v-if="attr?.c == 'White'" />
      <img src="@/assets/wine-red.svg" v-else-if="attr?.c == 'Red'" />
      <img src="@/assets/wine-rose.svg" v-else-if="attr?.c == 'Rose'" />
      <img src="@/assets/wine-orange.svg" v-else-if="attr?.c == 'Orange'" />
      <img src="@/assets/wine-white.svg" v-else />
      {{ attr?.c }} <span v-if="attr?.wt">&nbsp;&mdash;&nbsp;{{ removeNumbersDash() }}</span>
    </div>

    <div v-if="attr?.va"><img src="@/assets/wine-varietal.svg" />&nbsp;{{ attr?.va }}</div>
    <div v-if="attr?.rs"><img src="@/assets/rs-levels.svg" />&nbsp;{{ attr?.rs }}</div>
    <div v-if="attr?.fp"><img src="@/assets/farming.svg" />&nbsp;{{ attr?.fp }}</div>
    <div v-if="attr?.st"><img src="@/assets/spirit-type.svg" />&nbsp;{{ attr?.st }}</div>
    <div v-if="attr?.sst"><img src="@/assets/spirit-sub.svg" />&nbsp;{{ attr?.sst }}</div>
    <div v-if="attr?.ap"><img src="@/assets/appellation.svg" />&nbsp;{{ attr?.ap }}</div>
    <div v-if="attr?.k"><img src="@/assets/kosher.svg" />&nbsp;{{ attr?.k }}</div>
  </div>
</template>

<script>
export default {
  name: 'SkuAttributes',
  components: {},
  props: {
    attr: Object,
    mytype: {
      type: String,
      required: true,
      default: 'ITEM',
    },
  },
  data() {
    return {
      modNotes: '',
      edit: false,
    };
  },
  computed: {},
  methods: {
    // PUT OUR FUNCTIONS HERE FOR INTERACTION.
    removeNumbersDash() {
      return this.attr?.wt?.replace(/[0-9]/g, '').replace(/[-*]/g, '');
    },
  },
  created() {},
};
</script>
